
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire36ac"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire36ac"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $758067b5e7022af1$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["831rL","index.26e51d11.js","3eJh5","convertWorker.69d151b1.js"]'));

var $f79ebe0981b04c63$exports = {};
var $56b621a6dd25b2cb$exports = {};
"use strict";
$56b621a6dd25b2cb$exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? "import " + JSON.stringify(workerUrl) + ";" : "importScripts(" + JSON.stringify(workerUrl) + ");";
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: "application/javascript"
        }));
    }
};


let $f79ebe0981b04c63$var$url = new URL("convertWorker.69d151b1.js", import.meta.url);
$f79ebe0981b04c63$exports = $56b621a6dd25b2cb$exports($f79ebe0981b04c63$var$url.toString(), $f79ebe0981b04c63$var$url.origin, true);


const $b4e14b6b8da86996$var$worker = new Worker($f79ebe0981b04c63$exports);
const $b4e14b6b8da86996$var$workerCalls = {};
$b4e14b6b8da86996$var$worker.onmessage = (e)=>{
    $b4e14b6b8da86996$var$workerCalls[e.data.id](e.data.result);
    delete $b4e14b6b8da86996$var$workerCalls[e.data.id];
};
const $b4e14b6b8da86996$var$callWorkerWithReturn = (op, ...args)=>{
    const callId = Math.random().toString().substring(2);
    const prom = new Promise((resolve, reject)=>{
        $b4e14b6b8da86996$var$workerCalls[callId] = resolve;
    });
    $b4e14b6b8da86996$var$worker.postMessage({
        op: op,
        args: args,
        id: callId
    });
    return prom;
};
document.addEventListener("DOMContentLoaded", ()=>{
    const imageInput = document.getElementById("image_input");
    if (imageInput.files[0] !== undefined) $b4e14b6b8da86996$var$onImageInputChange();
    imageInput.addEventListener("input", $b4e14b6b8da86996$var$onImageInputChange);
});
const $b4e14b6b8da86996$var$downloadURI = (uri, name)=>{
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    link.click();
};
const $b4e14b6b8da86996$var$onImageInputChange = async ()=>{
    const file = document.getElementById("image_input").files[0];
    const fileExtensions = {
        "image/png": [
            "png"
        ],
        "image/jpeg": [
            "jpg",
            "jpeg"
        ],
        "image/webp": [
            "webp"
        ]
    };
    const imageOutDiv = document.getElementById("image_output");
    if (fileExtensions[file.type] === undefined) {
        imageOutDiv.innerText = "unsupported file type";
        return;
    }
    document.getElementById("input_div")?.classList.add("hide");
    document.getElementById("loading_div")?.classList.remove("hide");
    const fileNameSegs = file.name.split(".");
    if (fileExtensions[file.type].includes(fileNameSegs[fileNameSegs.length - 1])) fileNameSegs.pop();
    fileNameSegs.push("gif");
    const fileName = fileNameSegs.join(".");
    console.log("Gif filename will be " + fileName);
    const callTime = Date.now();
    const gifUrl = await $b4e14b6b8da86996$var$callWorkerWithReturn("convertImage", await file.arrayBuffer(), fileName);
    console.log("Worker call took", (Date.now() - callTime) / 1000, "seconds to complete");
    if (gifUrl === null) imageOutDiv.innerText = "something went wrong while converting that image :(";
    else {
        const imageEl = document.createElement("img");
        imageEl.src = gifUrl;
        imageOutDiv.setAttribute("image_file_name", fileName);
        imageOutDiv.innerHTML = `here\'s the gif. <a href="${gifUrl}" download>save</a>`;
        imageOutDiv.appendChild(imageEl);
    }
    document.getElementById("input_div").classList.remove("hide");
    document.getElementById("loading_div").classList.add("hide");
};


//# sourceMappingURL=index.26e51d11.js.map
